export default __webpack_public_path__ + "static/0180-018d0e981cbdbfa3f555c82bb070ab93.png";